import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import { AccountChat } from "@/lib/accountChatsParser"
import { PURGE } from "redux-persist"
import { RootState } from "./store"

type Jid = string
type UserChatsState = Record<Jid, AccountChat>

const initialState: UserChatsState = {}

export const userChatsSlice = createSlice({
  name: "userChats",
  initialState,
  reducers: {
    setUserChats: (state, action: PayloadAction<AccountChat[]>) => {
      const incomingJids = new Set(action.payload.map((c) => c.jid))
      const removedJids = Object.keys(state).filter(
        (jid) => !incomingJids.has(jid),
      )
      if (removedJids.length > 0) {
        console.warn(
          `[userChats] Removing ${removedJids.length} stale user chats:`,
          removedJids,
        )
        removedJids.forEach((jid) => delete state[jid])
      }
      action.payload.forEach((userChat) => {
        state[userChat.jid] = userChat
      })
    },
    addUserChat: (state, action: PayloadAction<AccountChat>) => {
      state[action.payload.jid] = action.payload
    },
    removeUserChat: (state, action: PayloadAction<Jid>) => {
      delete state[action.payload]
    },
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => initialState)
  },
})

export const { addUserChat, setUserChats, removeUserChat } =
  userChatsSlice.actions

export const selectUserChats = createSelector(
  (state: RootState) => state.userChats,
  (userChats) => userChats,
)

export const selectUserChatsAsList = createSelector(
  selectUserChats,
  (userChats) => Object.values(userChats),
)

export default userChatsSlice.reducer
